'use strict';

import analytics from '../../utils/analytics';
import foundationLoader from '../../utils/foundation-loader';
import user from '../../profile/user';

const classNames = {
	contactForm: 'contact-form',
	form: 'form',
	messageTemplate: 'message-template',
	submitButton: 'submit-button',
	failure: 'failure',
	success: 'success',
	failureText: 'failure-text'
};

let $modal, trackingData;

const defaultTrackingCategories = {
	defaultEmailDealer: 'Email Dealer',
	defaultRequestPhotos: 'Request Photos',
	defaultAskDealerQuestion: 'Ask Dealer Question'
};

const trackingActions = {
	successMessage: 'Submit Message',
	successMessageGallery: 'Submit Message (from gallery)',
	failMessage: 'Message Send Fail',
	failMessageGallery: 'Message Send Fail (from gallery)'
};

const tracking = {
	trackingData: {
		emailDealer: {
			category: defaultTrackingCategories.defaultEmailDealer,
			actionSuccess: trackingActions.successMessage,
			actionFail: trackingActions.failMessage
		},
		emailDealerGallery: {
			category: defaultTrackingCategories.defaultEmailDealer,
			actionSuccess: trackingActions.successMessageGallery,
			actionFail: trackingActions.failMessageGallery
		},
		requestPhotos: {
			category: defaultTrackingCategories.defaultRequestPhotos,
			actionSuccess: trackingActions.successMessage,
			actionFail: trackingActions.failMessage
		},
		requestPhotosGallery: {
			category: defaultTrackingCategories.defaultRequestPhotos,
			actionSuccess: trackingActions.successMessageGallery,
			actionFail: trackingActions.failMessageGallery
		},
		askDealerQuestion: {
			category: defaultTrackingCategories.defaultAskDealerQuestion,
			actionSuccess: trackingActions.successMessage,
			actionFail: trackingActions.failMessage
		}
	},

	setTrackingData: ($triggerElement) => {
		const contactType = $triggerElement.closest('[data-contact-form-type]').data('contact-form-type');

		trackingData = Object.assign({}, tracking.trackingData[contactType]);
		const triggerTracking = $triggerElement.data('ga-track');
		if (triggerTracking) {
			trackingData.category = triggerTracking.category;
			trackingData.label = triggerTracking.label;
		}
	},

	trackSubmissionEvent: function (sendSuccess) {
		if (!trackingData) {
			return;
		}

		const eventAction = sendSuccess ? trackingData.actionSuccess : trackingData.actionFail;
		analytics.trackEvent(trackingData.category, eventAction, trackingData.label);
	}
};

const form = {
	init: () => {
		$modal = $.findByBem(classNames.contactForm);

		$('[data-contact-form-type]').on('click.contact-form', function (e) {
			e.preventDefault();

			const $triggerElement = $(e.target);
			form.resetNewForm($triggerElement);

			$modal.foundation('open');
		});

		$(window).on('load', function () { // Foundation event handlers must be attached after window load otherwise foundation is not ready when it is set.
			const $contactForm = $.findByBem(classNames.contactForm);
			$contactForm.on('formvalid.zf.abide', function (e, target) {
				form.send(target);
			}).on("submit", function (e) {
				e.preventDefault();
			});
		});
	},

	resetFailedForm: ($failureMessage, $failureMessageText, $formElements, $submitButton, message) => {
		$failureMessageText.text(message);
		$failureMessage.show();
		$formElements.removeAttr('disabled');
		$submitButton.removeAttr('disabled');
	},

	resetNewForm: ($triggerElement) => {
		$modal.findByBem(classNames.contactForm, classNames.failure).hide();
		$modal.findByBem(classNames.contactForm, classNames.success).hide();
		$modal.findByBem(classNames.contactForm, classNames.submitButton).removeAttr('disabled');
		const $formElements = $modal.find('input, select, textarea');
		$formElements.removeAttr('disabled');
		$formElements.not('[type=hidden]').val('');

		tracking.setTrackingData($triggerElement);

		const postcode = user.getPostcode();
		if (postcode) {
			$modal.find('#postcode').val(postcode);
		}

		const contactType = $triggerElement.closest('[data-contact-form-type]').data('contact-form-type');
		const $messageTemplate = $modal
			.findByBem(classNames.contactForm, classNames.messageTemplate)
			.filter('[data-template-for=' + contactType + ']');

		if ($messageTemplate) {
			$formElements.filter('#message').val($messageTemplate.text().trim());
			$formElements.filter('#messageType').val(contactType);
		}
	},

	send: (target) => {
		const $formElements = $(target).find('input, select, textarea');
		const $failureMessage = $(target).findByBem(classNames.contactForm, classNames.failure);
		const $failureMessageText = $(target).findByBem(classNames.contactForm, classNames.failureText);
		const $successMessage = $(target).findByBem(classNames.contactForm, classNames.success);
		const $submitButton = $(target).findByBem(classNames.contactForm, classNames.submitButton);
		let errorMessage = 'There was a technical error sending your message, please try again later.';

		$failureMessage.hide();
		$formElements.attr('disabled', 'disabled');
		$submitButton.attr('disabled', 'disabled');

		const data = {
			'first_name': $formElements.filter('#firstName').val(),
			'last_name': $formElements.filter('#lastName').val(),
			'email': $formElements.filter('#email').val(),
			'phone': $formElements.filter('#phone').val() || null,
			'user_postcode': $formElements.filter('#postcode').val() || null,
			'message': $formElements.filter('#message').val() || null,
			'vehicle': $formElements.filter('#vehicleId').val(),
			'type': $formElements.filter('#messageType').val(),
			'vehicle_source': $formElements.filter('#vehicleSource').val(),
			'dealer_id': $formElements.filter('#dealerId').val()
		};

		$.ajax({
			url: '/api/contact-dealer/',
			method: 'post',
			contentType: 'application/json',
			data: JSON.stringify(data),
			success: () => {
				$successMessage.show();
				tracking.trackSubmissionEvent(true);
			},
			error: (error) => {
				if (error.responseText) {
					errorMessage = error.responseText;
				}

				form.resetFailedForm($failureMessage, $failureMessageText, $formElements, $submitButton, errorMessage);
				tracking.trackSubmissionEvent(false);
			}
		});
	}
};

export default {
	init() {
		foundationLoader.addPlugins(foundationLoader.PLUGINS.REVEAL);
		foundationLoader.addPlugins(foundationLoader.PLUGINS.ABIDE);

		form.init();
	}
}